<template>
  <AdditionalInfo
    v-if="
      productResponse &&
      technicalSpecificationsResponse &&
      selectedOffer &&
      selectedOffer.offerLegacyId
    "
    :instructions="productResponse.instructions"
    :listing-id="selectedOffer.offerLegacyId"
    :product-title="productResponse.titles.default"
    :technical-specifications="technicalSpecificationsResponse"
  />
</template>

<script setup lang="ts">
import AdditionalInfo from '~/scopes/product-core/components/presentationals/AdditionalInfo/AdditionalInfo.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchTechnicalSpecifications } from '~/scopes/product-core/composables/useFetch/useFetchTechnicalSpecifications/useFetchTechnicalSpecifications'

const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()
const { data: technicalSpecificationsResponse } =
  useFetchTechnicalSpecifications()
</script>
